export default __webpack_public_path__ + "static/media/chevron-down.3ae35594.svg";